

// App.js
import { BrowserRouter } from 'react-router-dom';
import { MessageProvider, useMessage } from './contexts/MessageContext';
import Router from './routes/Router';
import Alarm from './components/alarm/alarm';
import { useEffect } from 'react';
import { messaging, getToken, onMessage } from "./services/firebase";



function AppWrapper() {
  return (
    <MessageProvider>
      <App />
    </MessageProvider>
  );
}

function App() {
  const { setMessage } = useMessage();

  useEffect(() => {

    getToken(messaging, { vapidKey: "BOAeFgEYpRbkmty6TvqJ046p-u4Qu1RRS1wmxWPv0ZAK3EXMpbDTXeNsbm59whFAvX0duqoBMmqNiEykCe6H3DA" })
      .then((currentToken) => {
        if (currentToken) {
          console.log("FCM Token:", currentToken);

        } else {
          console.log("FCM 토큰 발급 실패: 사용자 푸시 허용 여부 확인");
        }
      })
      .catch((err) => {
        console.error("FCM 토큰 발급 에러:", err);
      });

if (!window.fcmListenerRegistered) {
    onMessage(messaging, (payload) => {
      console.log("웹에서 FCM 수신:", payload);

      const messageData = {
        title: payload.notification?.title || "제목 없음",
        body: payload.notification?.body || "내용 없음",
        data: payload.data || {},
      };

      setMessage(messageData); // Context에 전달
    });
window.fcmListenerRegistered = true;
}
  }, [setMessage]);

  return (
    <>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
      <Alarm />
    </>
  );
}

export default AppWrapper;
